export const enum Environment {
    LOCAL = 'local',
    DEV = 'dev',
    STAGING = 'staging',
    PRODUCTION = 'production',
}
